import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Lock, XCircle, Sparkles, Check } from 'lucide-react';

export function StageGateDialog({ gate, onClose }) {
  return (
    <Dialog open={!!gate} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="bg-card border-border rounded-sm max-w-md" data-testid="stage-gate-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-lg text-foreground flex items-center gap-2">
            <Lock className="w-5 h-5 text-amber-400" /> Prerequisites missing
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          To move this deal to <span className="text-foreground font-medium">{gate?.target_label}</span>, the following must be logged first:
        </p>
        <ul className="space-y-2 mt-1">
          {(gate?.missing || []).map((m, i) => (
            <li key={i} data-testid={`stage-gate-missing-${i}`}
              className="flex items-start gap-2 text-sm text-foreground/90 bg-amber-950/20 border border-amber-800/30 rounded-sm p-2.5">
              <XCircle className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" />
              <span>{m}</span>
            </li>
          ))}
        </ul>
        <p className="text-[11px] text-muted-foreground">
          As soon as the required activity is logged, the deal will offer a one-click move to the next stage automatically.
        </p>
        <div className="flex justify-end pt-1">
          <Button onClick={onClose} data-testid="stage-gate-close-btn"
            className="bg-secondary hover:bg-secondary/70 text-foreground border border-border rounded-sm text-xs h-8 px-4">
            Got it
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function StageSuggestionBanner({ suggestion, applying, onApply, onDismiss }) {
  if (!suggestion) return null;
  return (
    <div className="bg-emerald-950/20 border border-emerald-800/30 rounded-sm p-4" data-testid="stage-suggestion-banner">
      <div className="flex items-center gap-2 mb-2 flex-wrap">
        <Sparkles className="w-4 h-4 text-emerald-400" />
        <p className="text-sm font-medium text-emerald-400">Prerequisites met — ready for &ldquo;{suggestion.target_label}&rdquo;</p>
        {suggestion.at && (
          <span className="text-[10px] text-muted-foreground font-mono">
            {new Date(suggestion.at).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
          </span>
        )}
      </div>
      <p className="text-xs text-muted-foreground ml-6 mb-3">
        {suggestion.detail ? <>{suggestion.detail} — </> : null}
        the requirements for the next stage are fulfilled. Move this deal to &ldquo;{suggestion.target_label}&rdquo;?
      </p>
      <div className="ml-6 flex items-center gap-2 flex-wrap">
        <Button onClick={onApply} disabled={applying} data-testid="stage-suggestion-apply-btn"
          className="bg-emerald-700 hover:bg-emerald-600 text-white rounded-sm text-xs h-8 px-3">
          <Check className="w-3.5 h-3.5 mr-1" /> Move to {suggestion.target_label}
        </Button>
        <Button onClick={onDismiss} variant="outline" data-testid="stage-suggestion-dismiss-btn"
          className="border-border text-muted-foreground hover:text-foreground rounded-sm text-xs h-8 px-3">
          Not yet — dismiss
        </Button>
      </div>
    </div>
  );
}
